<div class="check-duplicates-modal-container">
  <div mat-dialog-title class="display-flex modal-header">
    <div class="subtitle mr-4">Duplicate Inspection Detected</div>
  </div>

  <mat-dialog-content>
    <div class="duplicated-items-container">
      <div class="duplicated-item" *ngFor="let item of data.inspections">
        There is
        <span class="label-highlighted">{{ data.templateName }}</span>
        for
        <span class="label-highlighted">{{ data.propertyName }}</span>
        <span *ngIf="item?.unit?.name">
          -
          <span class="label-highlighted">{{ item.unit.name }}</span>
        </span>
        <span class="navigate-inspection" (click)="onNavigateToInspection(item.id)">inspection</span>
        <ng-container *ngIf="item?.assignee && userMap.has(item.assignee)">assigned to</ng-container>
        <div
          class="display-flex align-items-center grid-gap-4"
          *ngIf="item?.assignee && userMap.has(item.assignee); else noAssignee">
          <app-avatar
            class="avatar"
            [useFullName]="true"
            [matTooltip]="userMap.get(item.assignee).displayName"
            [disableTooltip]="true"
            [userInfo]="userMap.get(item.assignee)"
            [containerCss]="'s-24'"></app-avatar>
          {{ userMap.get(item.assignee).displayName }}
        </div>

        <ng-template #noAssignee>without assignee</ng-template>
      </div>
    </div>

    <div class="info-text mt-20">Do you want to create a new one and cancel the existing?</div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button
      mat-stroked-button
      color="primary"
      mat-dialog-close
      (click)="onKeepEditing()"
      [disabled]="deletingInProgress$ | async">
      Keep editing
    </button>
    <button
      mat-raised-button
      type="submit"
      color="primary"
      (click)="onCancelAndCreate()"
      [disabled]="deletingInProgress$ | async">
      <span class="btn-container">
        <span>Yes, Create & Cancel</span>
        <mat-icon *ngIf="deletingInProgress$ | async">
          <mat-spinner color="accent" diameter="20"></mat-spinner>
        </mat-icon>
      </span>
    </button>
  </mat-dialog-actions>
</div>
